/**
 * 401 硬跳登录防重复标志：超时或进入登录页后必须清掉（F-8）。
 * 永不重置时，后续真 401 不再跳转。
 */

const RESET_MS = 4000;

export function beginSsoRedirect() {
	if (typeof window === 'undefined') return false;
	if (window.__ORG_AUTH_BOOT_RESTORE__ || window.__ZX_SSO_REDIRECTING__) return false;
	window.__ZX_SSO_REDIRECTING__ = true;
	if (window.__ZX_SSO_REDIRECTING_TIMER__) {
		clearTimeout(window.__ZX_SSO_REDIRECTING_TIMER__);
	}
	window.__ZX_SSO_REDIRECTING_TIMER__ = setTimeout(clearSsoRedirectFlag, RESET_MS);
	return true;
}

export function clearSsoRedirectFlag() {
	if (typeof window === 'undefined') return;
	window.__ZX_SSO_REDIRECTING__ = false;
	if (window.__ZX_SSO_REDIRECTING_TIMER__) {
		clearTimeout(window.__ZX_SSO_REDIRECTING_TIMER__);
		window.__ZX_SSO_REDIRECTING_TIMER__ = null;
	}
}
